// BFS Equivalent Mapping Logic — keys match BFS investment objective tiers; invest_objectives align with PRIMARY_OBJECTIVE / BFS canonical strings.
// Dropdown option lists live in src/constants/accountConstants.js and householdConstants.js (single source of truth).
export const BFS_MAPPING = {
  "PreservationOfCapital": {
    invest_objectives: ["Preservation of capital"],
    risk_tolerance: "Low",
    time_horizon: { start: 0, end: 1 },
    decision_making: "Consults with investment professional",
    source_of_funds: ["Income"],
    use_of_funds: "Retirement Savings",
  },
  "Income": {
    invest_objectives: ["Income"],
    risk_tolerance: "Moderate",
    time_horizon: { start: 1, end: 7 },
    decision_making: "Consults with investment professional",
    source_of_funds: ["Income"],
    use_of_funds: "Retirement Savings",
  },
  "GrowthAndIncome": {
    invest_objectives: ["Growth and Income"],
    risk_tolerance: "Moderate",
    time_horizon: { start: 1, end: 7 },
    decision_making: "Consults with investment professional",
    source_of_funds: ["Income"],
    use_of_funds: "Retirement Savings",
  },
  "LongTermGrowth": {
    invest_objectives: ["Long Term Growth"],
    risk_tolerance: "Moderately High",
    time_horizon: { start: 7, end: 100 },
    decision_making: "Consults with investment professional",
    source_of_funds: ["Income"],
    use_of_funds: "Retirement Savings",
  },
  "Speculation": {
    invest_objectives: ["Speculation"],
    risk_tolerance: "High",
    time_horizon: { start: 7, end: 100 },
    decision_making: "Consults with investment professional",
    source_of_funds: ["Income"],
    use_of_funds: "Retirement Savings",
  },
};

export const DEFAULT_STRUCTURES = {
  tax_info: {
    tax_bracket: "10-12%", // Default or empty? Leaving empty string for placeholder
    tax_percentage: "",
  },
  household_setup_defaults: {
    invest_objectives: [],
    risk_tolerance: "",
    time_horizon: null,
    decision_making: "",
    source_of_funds: [],
    use_of_funds: "",
    liquidity_requirements: {
      amount: { start: "", end: "" },
      time_horizon: { start: "", end: "" },
    },
  },
};
